<template>
    <div class="content content-full font-size-sm text-muted text-center">
        <strong>{{ yearRange }} &copy; <span data-toggle="year-copy"></span>Agritek 26 S.r.l.</strong>
    </div>
</template>

<script>
export default {
  computed: {
    yearRange() {
      const start = 2026;
      const current = new Date().getFullYear();
      if(start == current){
        return start;
      }
      return `${start}-${current}`;
    }
  }
}
</script>